import {useAppSelector} from '../store/hooks';

const useUserPermissions = (permissions: Nullable<string[]>) => {
  if (permissions === null) {
    return true;
  }

  const {permissions: currentUserPermissions} =
    useAppSelector(({permissions}) => permissions);

  const hasPermission = permissions?.some(
      (permission) => currentUserPermissions.includes(permission)
  );

  return hasPermission;
};

export default useUserPermissions;
